import { render, staticRenderFns } from "./CompanyCardRates.vue?vue&type=template&id=520e2b0a&scoped=true&"
import script from "./CompanyCardRates.vue?vue&type=script&lang=ts&"
export * from "./CompanyCardRates.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520e2b0a",
  null
  
)

export default component.exports